import { type_MAIN_LOADING } from '../types'

export const initialState = {
    loading: false,
}

export type SetLoadingAction = {
    type: typeof type_MAIN_LOADING
    payload: boolean
}

export const mainReducer = (
    state = initialState,
    { type, payload }: SetLoadingAction
) => {
    switch (type) {
        case type_MAIN_LOADING:
            return { ...state, loading: payload }
        default:
            return state
    }
}
